import { useState } from 'react';

interface FaqItemProps {
  question: string;
  answer: string;
}

export function FaqItem({ question, answer }: FaqItemProps) {
  const [open, setOpen] = useState(false);

  return (
    <div
      onClick={() => setOpen(!open)}
      className="cursor-pointer mb-3 transition-all duration-300"
      style={{
        background: open ? 'rgba(16, 185, 129, 0.06)' : 'rgba(255,255,255,0.03)',
        border: open ? '1px solid rgba(16, 185, 129, 0.25)' : '1px solid rgba(255,255,255,0.08)',
        borderRadius: 16,
        padding: '20px 24px',
      }}
    >
      <div className="flex justify-between items-center">
        <span
          className="flex-1 pr-4"
          style={{
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 600,
            fontSize: 15,
            color: '#E2E8F0',
            lineHeight: 1.4,
          }}
        >
          {question}
        </span>
        <div
          className="flex-shrink-0 flex items-center justify-center transition-all duration-300"
          style={{
            width: 28,
            height: 28,
            borderRadius: 8,
            background: open ? 'rgba(16,185,129,0.15)' : 'rgba(255,255,255,0.06)',
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M3 5L7 9L11 5" stroke={open ? '#10B981' : '#94A3B8'} strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>
      </div>
      <div
        className="overflow-hidden"
        style={{
          maxHeight: open ? 250 : 0,
          opacity: open ? 1 : 0,
          marginTop: open ? 12 : 0,
          transition: 'max-height 0.4s ease, opacity 0.35s ease, margin-top 0.35s ease',
        }}
      >
        <p
          style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 14,
            color: '#94A3B8',
            lineHeight: 1.7,
            margin: 0,
          }}
        >
          {answer}
        </p>
      </div>
    </div>
  );
}
